var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrenchPolynesia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0225C24.8366 32.0225 32 24.859 32 16.0225C32 7.1859 24.8366 0.0224609 16 0.0224609C7.16344 0.0224609 0 7.1859 0 16.0225C0 24.859 7.16344 32.0225 16 32.0225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94543 8.37027H30.0545C27.3409 3.39677 22.0647 0.0224609 16 0.0224609C9.93531 0.0224609 4.65912 3.39677 1.94543 8.37027V8.37027Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0224C22.0647 32.0224 27.3409 28.6481 30.0546 23.6746H1.94543C4.65912 28.6481 9.93531 32.0224 16 32.0224Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16.0224C21.5652 19.0961 19.0736 20.892 16 20.892C12.9264 20.892 10.4348 19.0961 10.4348 16.0224C10.4348 12.9488 12.9264 10.4572 16 10.4572C19.0736 10.4572 21.5652 12.9488 21.5652 16.0224Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16.0225C21.5652 19.0961 19.0736 21.5876 16 21.5876C12.9264 21.5876 10.4348 19.0961 10.4348 16.0225",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5216 14.6309H13.9129V17.4135H12.5216V14.6309Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 14.6309H19.4781V17.4135H18.0868V14.6309Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3042 12.5441H16.6955V17.4137H15.3042V12.5441Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrenchPolynesia);
export default __webpack_public_path__ + "static/media/french-polynesia.7266251b.svg";
export { ForwardRef as ReactComponent };